// V3合约地址配置 - 自动生成于 2026-07-10T06:16:04.429Z
// 网络: localhost (Chain ID: 1856)

export const CONTRACT_ADDRESSES_V3 = {
  systemConfig: "0x5FbDB2315678afecb367f032d93F642f64180aa3",
  usdtToken: "0xe7f1725E7734CE288F8367e1Bb143E90bb3F0512",
  lotteryNFT: "0xCf7Ed3AccA5a467e9e704C703E8D87F634fB0Fc9",
  feeManager: "0xDc64a140Aa3E981100a9becA4E685f962f0cF6C9",
  dividendManager: "0x5FC8d32690cc91D4c39d9d3abcBD16989F875707",
  prizePool: "0x0165878A594ca255338adfa4d48449f69242Eb8F",
  marketplace: "0xa513E6E4b8f2a923D98304ec87F64353C4D5C853",
  verirandOracle: "0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0"
};

export const NETWORK_INFO = {
  name: "localhost",
  chainId: 1856
};
